export class TerceraChartAdvancedParams {
    constructor() {
        this.DrawPointers = [];
    }
}
